/* eslint-disable prefer-rest-params */
/* eslint-disable no-var */
/* eslint-disable func-names */
/* eslint-disable prefer-destructuring */
/* eslint-disable vars-on-top */
import { languages } from '../i18n/config';
import { intercomChatConfig, isMaof } from '../settings';

const getAppId = () => {
  if (isMaof()) {
    return intercomChatConfig.APP_ID;
  }

  return intercomChatConfig.VMS_APP_ID;
};

export function loadIntercomWidget() {
  window.intercomSettings = {
    horizontal_padding: 0,
    vertical_padding: 20,
  };

  const w = window;
  const ic = w.Intercom;

  if (typeof ic === 'function') {
    ic('reattach_activator');
    ic('update', w.intercomSettings);
  } else {
    const d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = function () {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${getAppId()}`;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    };

    if (document.readyState === 'complete') {
      l();
    } else if (w.attachEvent) {
      w.attachEvent('onload', l);
    } else {
      w.addEventListener('load', l, false);
    }
  }
}

export function bootIntercomChat(userEmail, userId, userName, userHash) {
  if (window.Intercom) {
    window.Intercom('boot', {
      app_id: getAppId(),
      language_override: isMaof() ? languages.he_IL : undefined,
      alignment: isMaof() ? 'left' : 'right',
      name: userName,
      email: userEmail,
      user_id: userId,
      user_hash: userHash, // hmac
      created_at: new Date().getTime(),
    });
  }
}

export function closeIntercomChat() {
  if (window.Intercom) {
    window.Intercom('shutdown');
  }
}
